import { createContext, useContext, type PropsWithChildren } from 'react';
import { useUniversalNavigationContext } from '@fff-web/fff-global-nav';
import useCustomizeCampaignData from '../hooks/useCustomizeCampaignData';

type PersonalSurveyContextTypes = {
  isEditCampaignOpen: boolean;
  hasNMCAccess: boolean;
  isLoadingNMC: boolean;
};

const PersonalSurveyContext = createContext<PersonalSurveyContextTypes | undefined>(undefined);

const PersonalSurveyProvider = ({ children }: PropsWithChildren) => {
  const { hasNMCAccess, isLoadingNMC } = useCustomizeCampaignData();
  const { timer } = useUniversalNavigationContext();
  const { flashSaleId } = timer || {};
  const isEditCampaignOpen = !!flashSaleId;

  return (
    <PersonalSurveyContext.Provider value={{ isEditCampaignOpen, hasNMCAccess, isLoadingNMC }}>
      {children}
    </PersonalSurveyContext.Provider>
  );
};

export const usePersonalSurveyContext = () => {
  const context = useContext(PersonalSurveyContext);
  if (!context) {
    throw new Error('You must use the Personal Survey Provider in order to consume this context.');
  }
  return context;
};

export default PersonalSurveyProvider;
